<div class="list-group">
  @for (formEntry of forms(); track formEntry.formNumber) {
    <app-form-list-row [formEntry]="formEntry"></app-form-list-row>
  }
</div>
